module.exports = "/packs/images/homepage/facilities/spa_desktop~3fe59ae73072b716e92e99d489860260.jpg";